import { render, staticRenderFns } from "./card-notes.html?vue&type=template&id=24af381a&scoped=true&"
import script from "./card-notes.js?vue&type=script&lang=js&"
export * from "./card-notes.js?vue&type=script&lang=js&"
import style0 from "./card-notes.scss?vue&type=style&index=0&id=24af381a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af381a",
  null
  
)

export default component.exports